module.exports = __webpack_public_path__ + "static/media/tier-4.fe3f13e3.jpg";